//Login.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaUser, FaLock, FaSignInAlt, FaEye, FaEyeSlash } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Login.css';
import logoImage from '../Images/VaculinkIcon/vaculink-logo.png';
import axios from 'axios';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import { FaExclamationTriangle } from 'react-icons/fa';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    // Check for username and password in query parameters
    const params = new URLSearchParams(location.search);
    const usernameFromUrl = params.get('username');
    const passwordFromUrl = params.get('password');

    if (usernameFromUrl && passwordFromUrl) {
      // Trigger login if parameters are found
      handleLogin(usernameFromUrl, passwordFromUrl);
    }
  }, [location]);

  const [masterLoggedInUsers, setMasterLoggedInUsers] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      //console.log('Login failed: Username or password is empty');
      alert('Username and password cannot be empty');
      return;
    }

    try {
      //console.log('Attempting to log in with username:', username);

      // Regular login attempt
      const loginSuccess = await onLogin(username, password);

      if (loginSuccess) {
        // After a successful login, check the RoleID of the logged-in user
        const storedUserData = JSON.parse(sessionStorage.getItem('userData')); // Assuming user data is stored in sessionStorage

        if (storedUserData && (storedUserData.RoleID === 1 || storedUserData.RoleID === 2)) {
          //console.log('User has RoleID 1 or 2, redirecting to /MasterDashboard');
          navigate('/MasterDashboard');  // Redirect to MasterDashboard
        } else {
          //console.log('User has a different RoleID, redirecting to dashboard...');
          navigate('/dashboard');  // Redirect to regular dashboard
        }
      } else {
        //console.log('Regular login failed for username:', username);
        alert('Invalid username or password');
      }
    } catch (error) {
      console.error('Error during login:', error);
      alert('An error occurred while trying to log in. Please try again.');
    }
  };

  const handleLogin = async (username, password) => {
    const loginSuccess = await onLogin(username, password);
    if (loginSuccess) {
      navigate('/dashboard');
    }
  };

  useEffect(() => {
    if (success) {
      navigate('/dashboard');
    }
  }, [success, navigate]);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem('username');
    const storedPassword = sessionStorage.getItem('password');

    if (storedUsername && storedPassword) {
      handleLogin(storedUsername, storedPassword);
    } else {
      console.error('No credentials found in sessionStorage');
    }
  }, []);

  const handleForgotPassword = () => {
    //alert('Forgot Password Clicked');
  };

  const handleCloseAlert = () => {
    setShowAlert(false); // Close the alert
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: '#EBEFF3' }}>
      {/* Displaying the alert */}
      {/*
      {showAlert && (
        <div className="alert-bar">
          <div className="alert-header">
            <FaExclamationTriangle className="alert-icon" />
            <h3 className="alert-title">Important Notice</h3>
          </div>
          <div className="alert-content">
            We would like to inform you that the Tele2 service provided by Vaculink has been discontinued.
            If you need assistance with transitioning to another service, please reach out to us at
            <span className="email-links">
              <a href="mailto:info@vaculink.com" className="email-link">info@vaculink.com</a>
            </span>
          </div>
          <div className="alert-note">
            *Note: This notice does not affect the newly migrated Ewon device router projects.
          </div>

          <div className="security-notice">
            <p>
              <FaLock className="security-icon" />
              <strong> Security Notice: </strong>We have recently updated our login functionality to enhance your security.
              To continue using our services, please sign up below to receive your new login details.
              <a href="/signup" className="security-action">Sign Up for New Login Details </a>
            </p>
          </div>

          <button className="close-btn" onClick={handleCloseAlert}>×</button>
        </div>
      )}
      */}

      {/* Open this if on the top any alerts need to display <div className="card" style={{ width: '750px', height: '300px', borderRight: '5px solid dodgerblue', borderBottom: '5px solid dodgerblue', marginTop: '60px' }}> */}
      <div className="card" style={{ width: '750px', height: '300px', borderRight: '5px solid dodgerblue', borderBottom: '5px solid dodgerblue' }}>
        <div className="card-body bg-lightblue rounded-10 shadow" >
          <div className="d-flex justify-content-between mb-4">
            <div style={{ width: '60%', marginTop: '45px', marginLeft: '30px' }}>
              <img src={logoImage} alt="Vaculink Logo" style={{ maxWidth: '30%', height: 'auto' }} />
              <h4 style={{ color: 'black', fontSize: '2.28rem', lineHeight: '100%', marginTop: '20px' }}>
                Vaculink Portal
              </h4>
              <p style={{ color: 'gray', fontSize: '1rem', textAlign: 'center', marginRight: '-35px' }}>Version 2.0r</p>
            </div>
            <div style={{ width: '50%', marginTop: '45px', marginRight: '30px' }}>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaUser />
                    </span>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="form-control"
                      placeholder="Username"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaLock />
                    </span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="form-control"
                      placeholder="Password"
                    />
                    <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100 mt-1"
                  style={{
                    padding: '8px',
                    backgroundColor: 'dodgerblue',
                    border: 'none',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#007bff'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'dodgerblue'}
                  onClick={(e) => e.target.style.backgroundColor = '#0056b3'}
                  onMouseUp={(e) => e.target.style.backgroundColor = 'dodgerblue'}
                  onMouseDown={(e) => e.target.style.backgroundColor = '#004286'}
                >
                  <FaSignInAlt style={{ marginRight: '8px' }} /> Login
                </button>
              </form>
              <div className="mt-2 text-center">
                <span
                  onClick={handleForgotPassword}
                  className="forgot-password"
                >
                  <Link to="/forgot-password" className="forgot-password">
                    Forgot Password?
                  </Link>
                </span>
              </div>
            </div>
          </div>
          {/*<div style={{ textAlign: 'center', fontSize: '14px' }}>
            Powered by <a href="https://aplus-technology.com/" target="_blank" rel="noopener noreferrer">Aplus Technology</a>
          </div>*/}
        </div>
      </div>
    </div>
  );
};

export default Login;
